import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';

export default function About() {
  return (
    <div className="min-h-screen">
      <Navbar />

      {/* Hero Section */}
      <section className="relative h-[380px] md:h-[500px] w-full overflow-hidden mt-20 md:mt-24">
        <img
          src="https://readdy.ai/api/search-image?query=Close-up%20detail%20of%20modern%20skyscraper%20glass%20curtain%20wall%20facade%20reflecting%20warm%20golden%20sunset%20light%2C%20elegant%20geometric%20grid%20pattern%20of%20glass%20panels%2C%20subtle%20warm%20amber%20reflections%20on%20cool%20silver%20glass%2C%20clean%20architectural%20photography%2C%20dramatic%20evening%20light%20on%20premium%20commercial%20building%2C%20high%20resolution%20sharp%20detail%2C%20serene%20sophisticated%20mood%2C%20no%20cartoon%20style%2C%20photorealistic%20quality&width=1600&height=900&seq=about-hero-03&orientation=landscape&nocache=true"
          alt="We explore for opportunities"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/30 to-black/50" />
        <div className="absolute inset-0 flex items-center justify-center">
          <h1 className="text-white text-2xl md:text-4xl font-heading font-medium text-center px-6 max-w-3xl leading-snug">
            We explore for opportunities in unexpected areas
          </h1>
        </div>
      </section>

      {/* About Content */}
      <section className="py-12 md:py-20 bg-white">
        <div className="section-container max-w-4xl">
          <div className="space-y-6 text-sm text-gray-600 leading-relaxed">
            <p className="text-xl md:text-2xl text-brand-gold font-heading font-bold leading-snug">
              Deeply ingrained in local knowledge, cultures and jurisdictions whilst constantly adapting to market conditions, Property Growth aims to explore for opportunities in unexpected areas that are undervalued which provides us the resources and connections we need for operating a profitable business in the region.
            </p>
            <p>
              In addition to thematic portfolios in Asia Pacific, we focus mostly on developed, liquid markets. By identifying the factors driving local economies and real estate markets, we present clients the region&apos;s potential growth.
            </p>
            <p>
              With institutional and private owners doubling down on their Asia Pacific commercial real estate portfolio and while capital protection is crucial, our implemented strategies employ a consistent investment approach and aim to deliver good risk-adjusted returns. Data centres, industrial/logistics, residential mixed used are among the industries we focus on.
            </p>
          </div>
        </div>
      </section>

      {/* Handshake Section */}
      <section className="relative h-[300px] md:h-[400px] w-full overflow-hidden">
        <img
          src="https://readdy.ai/api/search-image?query=Striking%20modern%20cable-stayed%20bridge%20dominant%20in%20the%20frame%20spanning%20across%20a%20wide%20river%2C%20large%20and%20prominent%20bridge%20filling%20the%20lower%20two-thirds%20of%20composition%2C%20dramatic%20towering%20white%20bridge%20pylons%20with%20radiating%20cables%2C%20clear%20blue%20sky%20with%20scattered%20soft%20white%20clouds%20above%2C%20warm%20golden%20late%20afternoon%20sunlight%20gently%20illuminating%20bridge%20structure%20and%20calm%20water%20with%20subtle%20amber%20reflections%2C%20distant%20city%20skyline%20on%20horizon%20beneath%20bridge%2C%20editorial%20architectural%20photography%2C%20balanced%20natural%20daylight%20with%20warm%20golden%20highlights%2C%20majestic%20powerful%20atmosphere%2C%20photorealistic%20quality&width=1600&height=600&seq=handshake-01&orientation=landscape&nocache=true"
          alt="Modern bridge connecting markets"
          className="w-full h-full object-cover object-center scale-110"
        />
        <div className="absolute inset-0 bg-black/10" />
        <div className="absolute inset-0 flex items-center justify-center">
          <div className="section-container max-w-2xl text-center">
            <p className="text-xl md:text-2xl text-white font-heading font-bold leading-snug">
              By identifying the factors driving local economies and real estate markets, we present clients the region&apos;s potential growth.
            </p>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
}